export function stringifyKey(type, id) {
    return `${type}.${String(id)}`;
}
//# sourceMappingURL=stringifyKey.js.map